const darkModeToggle = ({commit,getters}, args) => {
  commit('DARK_MODE', !getters['darkMode']);
};

export default {
  darkModeToggle
}
